export default __webpack_public_path__ + "static/media/datapower.3d680f70.svg";